import { DatasetBrowserData } from '@mode/shared/contract-common';
import { CreateGoogleSheetProps } from './create-sheet-props';

export abstract class GoogleSheetFacade {
  abstract createGoogleSheetDataset(props: CreateGoogleSheetProps): void;
  abstract importDataset(dataset: DatasetBrowserData): void;
}
